import { http, HttpResponse, delay } from 'msw';

import { mockShareableSecret } from '@/mocks/data/secretsData';

export const secretsHandlers = [
  http.post(
    '*/v1/organizations/:organizationId/shareable-secrets/retrieve',
    async () => {
      await delay();
      return HttpResponse.json(mockShareableSecret, { status: 200 });
    }
  ),
];
